<template>
<div class="accountExtract">
    <div class="status" v-if="showEndPage">
        <img src="../assets/processing.png" alt="" width="27%">
    </div>

    <div class="status" v-if="this.status == '1'">
        <img src="../assets/success.png" alt="" width="27%">
        <p>{{tradeTypeText}}成功</p>
    </div>

    <div class="status" v-if="this.status == '2'">
        <img src="../assets/fail.png" alt="" width="27%">
        <p>{{tradeTypeText}}失败</p>
    </div>

    
     <div class="info"  v-if="this.status !== '1' && this.status !== '2'">
         <p class="title">
            {{tradeTypeText}}进行中
         </p>
          <!-- <p class="deal_amount">¥<span class="balance">330.00</span></p> -->
     </div>

     <p class="hint" v-if="showEndPage">
         您可以等待订单完成或继续浏览其他页面，
             处理完成后订单信息将会自动同步
     </p>

     <div class="wrap-btn-foot" @click="toRedirect" v-if="this.status == '1' || this.status == '2'">
         <button  class="btn-md">完成</button>
     </div>

     <div class="wrap-btn-foot"  v-if="showEndPage"  @click="toRedirect">
         <button  class="btn-md">关闭</button>
     </div>
</div>
</template>

<script>
import { Checklist } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { Cell } from 'mint-ui';
export default {
  name: 'Status',
  data () {
    return {
        amount:'',
        showEndPage:false,
        countTimer:null,
        trade_type:'',
        status:'',
        redirect:'',
        payTimer:null,
        bill_id:''
    }
  },
  computed: {
      tradeTypeText(){
          if(this.trade_type == '1'){
              return '充值';
          }else if(this.trade_type == '2'){
              return '提现';
          }else{
              return ''
          }
      }
  },
  beforeMount(){
      let queryObj = this.$route.query
      if(typeof(queryObj.bill_id)!=='undefined'){
          this.bill_id = queryObj.bill_id;
      }
  },
   mounted() {
        Indicator.open();
        if(this.bill_id !== ''){
            this.payTimer = setInterval(this.getStatus,1500);
            this.countTimer = setTimeout(()=>{
                if(this.status !== '1' && this.status !== '2'){
                    Indicator.close();
                    this.showEndPage = true;
                }
            },10000);
        }
  },
  beforeDestroy() {
    this.payTimer && clearInterval(this.payTimer);
     this.countTimer && clearTimeout(this.countTimer);
  },
   methods: {
    toRedirect(){
         window.location = this.redirect;
    },
    getStatus(){
        const url = '/v1/person/wallet/recharge_withdraw_info';
        const params = {
            bill_id:this.bill_id,
        }
        Post(url,params).then((res)=>{
            this.status = res.status;
            this.trade_type = res.trade_type;
            if(this.status == '1' || this.status == '2'){
                 this.showEndPage = false;
                 clearInterval(this.payTimer);
                 Indicator.close();
            }
            this.redirect = res.redirect;
        }).catch((error)=>{
            Toast({
                 message: "code:"+error.code+" message:"+error.msg,
                 duration: 3000
             });
        })
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.status{
    margin: 0.6rem auto 0.3rem;
    text-align: center;
}
.status p{
    margin-top:10px;
}
.info{
    margin:.2rem;
    text-align: center;
}
.deal_amount{
    margin:0.1rem;
    font-size: .35rem;
}
.wrap-btn-foot{
    margin: .7rem 0 0;
    padding: 0 .15rem;
}
.btn-md {
    -webkit-tap-highlight-color: rgba(255,255,255,0);
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    font-size: 100%;
    font-family: inherit;
    outline-offset: 0;
    outline-style: none;
    outline-width: 0;
    -webkit-font-smoothing: inherit;
    background-image: none;
    text-indent: 0;
    padding-left: 0;
    padding-right: 0;
    border: 0;
    background-color: #3b8aff;
    color: #fff;
    border: none;
    width: 100%;
    height: .44rem;
    line-height: .44rem;
    font-size: 16px;
}
.hint{
    margin: 0.2rem;
    text-align: center;

}
</style>



// WEBPACK FOOTER //
// src/views/Status.vue